// extracted by mini-css-extract-plugin
export default {"layout":"PrivateLayout_layout__p7avJ","content":"PrivateLayout_content__Vr7Jy"};